import { render } from "./CommentList.vue?vue&type=template&id=1d6af605&scoped=true"
import script from "./CommentList.vue?vue&type=script&lang=js"
export * from "./CommentList.vue?vue&type=script&lang=js"

import "./CommentList.vue?vue&type=style&index=0&id=1d6af605&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d6af605"]])

export default __exports__